import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: true,
  deployUrl: 'https://victorious-bush-043d64f1e.azurestaticapps.net/',
  useMockEnvironment: false
};
